module.exports = __webpack_public_path__ + "static/variable-universal-life-insurance-hero-mobile.56ce265e.webp";